import React, { useEffect } from 'react';
import useEvent from '../hooks/useEvent';
import { useClearSessionAndRedirectToLogin } from '../context/hooks';
import Cookies from 'js-cookie';
import { COOKIE_NAMES } from '../constants';
import * as services from '../services';

export const AppEvent = {
  onPingGroupUpdated: 'onPingGroupUpdated',
  onUserInvalidSession: 'onUserInvalidSession',
  onRefreshToken401: 'onRefreshToken401',
};

const EventHandler = () => {
  const clearSessionAndRedirectToLogin = useClearSessionAndRedirectToLogin();
  useEvent(AppEvent.onUserInvalidSession, () => {
    clearSessionAndRedirectToLogin();
  });

  useEvent(AppEvent.onRefreshToken401, () => {
    clearSessionAndRedirectToLogin();
  });

  useEvent(AppEvent.onPingGroupUpdated, (data) => {
    console.log('AppEvent', 'onPingGroupUpdated', data);
  });
  return null;
};

export default EventHandler;
